import Validation from "../../utils/inputsValidation";
import {__loco} from "../../utils/localization";

const validation = new Validation();

export const stripeFields = ['holder', 'stipe']

export const paymentValidators = {
    holder: (value) => {
        if(!isEmpty(value.trim())) {
            return null
        }
        return __loco('Please enter your card holder full name.')
    },
}

export const validators = {
    payer_first_name: (value) => {
        if(!isEmpty(value.trim())) {
            return null
        }
        return __loco('Please enter your first name.')
    },
    payer_last_name: (value) => {
        if(!isEmpty(value.trim())) {
            return null
        }
        return __loco('Please enter your last name.')
    },
    payer_email: (value) => {
        if(!isEmpty(value) && validation.validateEmail(value)) {
            return null
        }
        if(isEmpty(value)) {
            return __loco('Please enter your email.')
        }
        return __loco('Please enter valid email.')
    },
    payer_phonenumber: (value) => {

        if (!isEmpty(value) && validation.validatePhoneRequired(value)) {
            return null
        }

        if(isEmpty(value)) {
            return __loco('Please enter your phone number.')
        }
        return __loco('Please enter valid phone number.')
    },
    checkOutTermsCondition: (value) => {
        if (value === true) {
            return null
        }
        return __loco('Please accept terms & conditions.')
    }
}


export function validatePersonalInformationPaymentAndTerms() {

    const activePaymentMethod = $('.checkout_item__payment_method.active');

    if(validatePersonalInformationInputs() &&
        $('#checkOutTermsCondition').is(":checked")
    ){
        return true;
    }
        return false;
}

export function validatePersonalInformationInputs() {
    // const fullName = document.getElementById('payer_name').value;

    const first_name = document.getElementById('payer_first_name').value;
    const last_name = document.getElementById('payer_last_name').value;
    const email =  document.getElementById('payer_email').value;
    const phoneNumber = document.getElementById('payer_phonenumber').value;
    const guest_detail_show_checkout_page = document.getElementById('guest_detail_show_checkout_page').value;
    // const area_code = document.querySelector('.iti__selected-flag').value;

    if (!isEmpty(first_name) && !isEmpty(last_name) &&
        !isEmpty(email) && validation.validateEmail(email) &&
        ((!isEmpty(phoneNumber) && validation.validatePhoneRequired(phoneNumber) ) || guest_detail_show_checkout_page)
    ){
        return true;
    }

    return false;
}

export function isEmpty(val){
    return !val || val === ''
}
